<template lang="pug">
  transition(name="fade" mode="out-in")
    div.c-mask(v-if="showMask === true")
      div.c-mask-wrapper
      pulse-loader(color="#F8CA4F" size="80px")
</template>

<style lang="sass" scoped>
@import 'component'
</style>

<script>
import PulseLoader from 'vue-spinner/src/BounceLoader';

export default {
  components: {
    PulseLoader,
  },

  data() {
    return {
      showMask: false,
    };
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    this.showMask = this.show;

    this.$ebus.$on('c-mask-lock', () => {
      this.showMask = true;
    });

    this.$ebus.$on('c-mask-unlock', () => {
      this.showMask = false;
    });
  },
};
</script>
